import { render, staticRenderFns } from "./ant-s-t.vue?vue&type=template&id=504d5ea6&scoped=true"
import script from "./ant-s-t.vue?vue&type=script&lang=js"
export * from "./ant-s-t.vue?vue&type=script&lang=js"
import style0 from "./ant-s-t.vue?vue&type=style&index=0&id=504d5ea6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "504d5ea6",
  null
  
)

export default component.exports